/**
 * Provider de Segurança Global
 * Inicializa e gerencia todas as medidas de segurança da aplicação
 */

import React, { useEffect } from 'react';
import { initActivityMonitoring } from '@/lib/security';

interface SecurityProviderProps {
  children: React.ReactNode;
}

export const SecurityProvider: React.FC<SecurityProviderProps> = ({ children }) => {
  useEffect(() => {
    // Inicializa monitoramento de atividade (logout automático após inatividade)
    initActivityMonitoring();
    
    // Adiciona headers de segurança através de meta tags
    const addSecurityHeaders = () => {
      // Content Security Policy
      const csp = document.createElement('meta');
      csp.httpEquiv = 'Content-Security-Policy';
      csp.content = [
        "default-src 'self'",
        "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://ai.gateway.lovable.dev https://*.lovableproject.com",
        "style-src 'self' 'unsafe-inline'",
        "img-src 'self' data: https: blob:",
        "font-src 'self' data: https://fonts.gstatic.com",
        "connect-src 'self' https://*.supabase.co https://ai.gateway.lovable.dev wss://*.supabase.co https://*.lovableproject.com",
        "frame-src 'self' https://www.youtube.com https://youtube.com",
        "media-src 'self' https:",
        
        "base-uri 'self'",
        "form-action 'self'",
      ].join('; ');
      
      // X-Content-Type-Options
      const contentType = document.createElement('meta');
      contentType.httpEquiv = 'X-Content-Type-Options';
      contentType.content = 'nosniff';
      
      // Referrer Policy
      const referrer = document.createElement('meta');
      referrer.name = 'referrer';
      referrer.content = 'strict-origin-when-cross-origin';
      
      document.head.appendChild(csp);
      document.head.appendChild(contentType);
      document.head.appendChild(referrer);
    };
    
    addSecurityHeaders();
    
    // Limpa dados sensíveis ao fechar a aba
    const cleanup = () => {
      // Limpa qualquer dado temporário sensível
      sessionStorage.clear();
    };
    
    window.addEventListener('beforeunload', cleanup);
    
    return () => {
      window.removeEventListener('beforeunload', cleanup);
    };
  }, []);
  
  return <>{children}</>;
};
